// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Oj2m0QkjyYRC9WehA0Zr{align-items:center;display:flex}.Bre8NtGhHEgHRRm9uZG5{background:var(--content-neutral-primary);border-radius:50%;width:2px;height:2px;margin:0 8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stateName": `Oj2m0QkjyYRC9WehA0Zr`,
	"dot": `Bre8NtGhHEgHRRm9uZG5`
};
export default ___CSS_LOADER_EXPORT___;
